// src/services/auctionService.js
import api from './api';

const listSessions = (statusesOrOptions = null, maybeOptions = {}) => {
    const isOptionsObject = statusesOrOptions && typeof statusesOrOptions === 'object' && !Array.isArray(statusesOrOptions);
    const statuses = isOptionsObject ? statusesOrOptions.statuses : statusesOrOptions;
    const options = isOptionsObject ? statusesOrOptions : maybeOptions;
    const params = {};

    if (statuses) {
        params.status = Array.isArray(statuses)
            ? statuses.join(',')
            : statuses;
    }

    if (options.cursor) {
        params.cursor = options.cursor;
    }
    if (options.limit) {
        params.limit = options.limit;
    }

    return api.get('auction/sessions', { params });
};

const getSession = (sessionId) => {
    return api.get(`auction/session/${sessionId}`);
};

const getBids = (sessionId) => {
    return api.get(`auction/session/${sessionId}/bids`);
};

const createAuctionSession = (tokenId, payload) => {
    return api.post(
        `auction/sessions/${tokenId}`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
    );
};

const startAuctionSession = (sessionId) => {
    return api.post(`auction/session/${sessionId}/start`);
};

const updateAuctionSession = (sessionId, payload) => {
    return api.put(`auction/session/${sessionId}`, payload);
};

const deleteAuctionSession = (sessionId) => {
    return api.delete(`auction/session/${sessionId}`);
};

const getInvestorDashboardStats = () => {
    return api.get('auction/dashboard-stats');
};

const auctionService = {
    getAuctionSessions: listSessions, // keep for backward compatibility if any
    listSessions,
    getAuctionSession: getSession, // keep for backward compatibility if any
    getSession,
    getBids,
    createAuctionSession,
    startAuctionSession,
    getInvestorDashboardStats,
    updateAuctionSession,
    deleteAuctionSession,
};

export default auctionService;
